import { redirect } from 'react-router';
import { tokenStorage } from '@/services/tokenStorage';

/** Redirect before the protected live tree starts loading. */
export function requireAuthLoader() {
  return tokenStorage.hasSession() ? null : redirect('/login');
}
